import { css } from "styled-components";
import { sizes } from "./sizes";

export const media = {
  tablet: (styles: TemplateStringsArray) => css`
    @media (min-width: ${sizes.tablet}) and (max-width: 1200px) {
      ${styles}
    }
  `,
  laptop: (styles: TemplateStringsArray) => css`
    @media (min-width: ${sizes.laptop}) {
      ${styles}
    }
  `,
  desktop: (styles: TemplateStringsArray) => css`
    @media (min-width: ${sizes.desktop}) {
      ${styles}
    }
  `,
};
